import { useMutation } from '@tanstack/react-query';

import { useSessionWriter } from '../../shared/session';
import { loginWithPassword } from './session';

/** Мутация входа: успех кладёт сессию в кэш, откуда её читает гейт и экраны. */
export function useLogin() {
  const session = useSessionWriter();
  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      loginWithPassword(email, password),
    onSuccess: session.set,
  });
}
